const AuthLayout = ({ children }) => (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="w-full rounded shadow">{children}</div>
    </div>
  );
  export default AuthLayout;